import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from 'prosemirror-state';
import {
  // convertListsToEditorIndentList,
  convertFromTreeToFlatList,
} from './listConvertionUtils';

export const PasteConverter = Extension.create({
  name: 'pasteConverter',

  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey('pasteConverter'),
        props: {
          handlePaste: (view, event) => {
            const clipboardText = event.clipboardData?.getData('text/html');
            if (clipboardText) {
              // const updatedHtml = convertListsToEditorIndentList(
              //   clipboardText
              //     .replaceAll(/\n|\r/g, '')
              //     .replaceAll(/<span[^>]+>/g, '<span style="display:inline;">')
              // );
              const updatedHtml = convertFromTreeToFlatList(
                clipboardText
                  .replaceAll(/\n|\r/g, '')
                  .replaceAll(/<!--StartFragment-->/g, '')
                  .replaceAll(/<!--EndFragment-->/g, '')
                  .replaceAll(/<span[^>]+>/g, '<span style="display:inline;">'),
              );
              this.editor.commands.insertContent(updatedHtml);
              return true;
            }

            return false;
          },
        },
      }),
    ];
  },
});
